import { useEffect, useState } from 'react'
import EditPreviewContainer from '../components/editor/EditPreviewContainer'
// import { Nav } from '../components/editor/Nav'
import { SectionsColumn } from '../components/editor/SectionsColumn'
import useLocalStorage from '../hooks/useLocalStorage'
import { allSectionTemplates } from '../data'
import { useParams, useLocation } from 'react-router-dom';

export default function Editor() {
  // Default language
  // const DEFAULT_LANG = 'hi'
  const { projectId } = useParams()
  const { state } = useLocation(); // This gets { project: {...} }

  // console.log("projectId:", projectId, "\n", "state", state?.project?.template )

  // Load templates safely
  const initialTemplates = allSectionTemplates[state?.project?.template] ?? []

  const [templates, setTemplates] = useState(initialTemplates)
  // eslint-disable-next-line
  const [language, setLanguage] = useState(state?.project?.language)

  const [selectedSectionSlugs, setSelectedSectionSlugs] = useState([])
  const [sectionSlugs, setSectionSlugs] = useState(
    initialTemplates.map((t) => t.slug)
  )
  const [focusedSectionSlug, setFocusedSectionSlug] = useState(null)
  // eslint-disable-next-line 
  const [showDrawer, toggleDrawer] = useState(false)

  const { backup } = useLocalStorage()

  // Restore backup if exists
  useEffect(() => {
    if (Array.isArray(backup) && backup.length) {
      setTemplates(backup)
      setSectionSlugs(backup.map((t) => t.slug))
    }
  }, [backup])

  const getTemplate = (slug) =>
    templates.find((t) => t.slug === slug)

  useEffect(() => {
    if (selectedSectionSlugs.length) {
      localStorage.setItem(
        'current-slug-list',
        selectedSectionSlugs.join(',')
      )
      setFocusedSectionSlug(selectedSectionSlugs[0])
    }
  }, [selectedSectionSlugs])

  const drawerClass = showDrawer ? '' : '-translate-x-full md:transform-none'

  return (
    <div className="w-full h-full mt-12 pt-6">
      <div className="flex md:px-6">
        <div
          className={`absolute md:static p-6 md:p-0 bg-white shadow
          transform transition-transform duration-500 ease-in-out ${drawerClass}`}
        >
          <SectionsColumn
            selectedSectionSlugs={selectedSectionSlugs}
            setSelectedSectionSlugs={setSelectedSectionSlugs}
            sectionSlugs={sectionSlugs}
            setSectionSlugs={setSectionSlugs}
            setFocusedSectionSlug={setFocusedSectionSlug}
            focusedSectionSlug={focusedSectionSlug}
            templates={templates}
            originalTemplate={initialTemplates}
            setTemplates={setTemplates}
            getTemplate={getTemplate}
          />
        </div>

        <div className="">
          <EditPreviewContainer
            templates={templates}
            setTemplates={setTemplates}
            getTemplate={getTemplate}
            focusedSectionSlug={focusedSectionSlug}
            selectedSectionSlugs={selectedSectionSlugs}
            setSelectedSectionSlugs={setSelectedSectionSlugs}
            projectId={projectId || "demo-1"}
            language={language}
          />
        </div>
      </div>
    </div>
  )
}
